import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcThreats = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "12",
  fill: "var(--mds-nav-icon-medium)",
  r: "2"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M11 2a1 1 0 1 1 2 0v.803A9.254 9.254 0 0 1 21.197 11H22a1 1 0 1 1 0 2h-.803A9.254 9.254 0 0 1 13 21.197V22a1 1 0 1 1-2 0v-.803A9.254 9.254 0 0 1 2.803 13H2a1 1 0 1 1 0-2h.803A9.254 9.254 0 0 1 11 2.803V2Zm8.182 9H19a1 1 0 1 0 0 2h.182A7.254 7.254 0 0 1 13 19.182V19a1 1 0 1 0-2 0v.182A7.254 7.254 0 0 1 4.818 13H5a1 1 0 1 0 0-2h-.182A7.254 7.254 0 0 1 11 4.818V5a1 1 0 1 0 2 0v-.182A7.254 7.254 0 0 1 19.182 11Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcThreats");

export { IcThreats };
//# sourceMappingURL=ic-threats.js.map
